/*
 * @Descripttion: 
 * @version: 
 * @Author: liux
 * @Date: 2019-11-21 14:58:03
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-02 13:53:54
 */
/*  
 通讯出口
 归属：企通前端平台-ECP V5.1
 版权：2014-2020 企通软件技术有限公司
 --------------------------------------------------------------------------------
 作者：刘鑫                           创建日期：2018/03/22
 修改：                               修改日期：
 修改内容
 --------------------------------------------------------------------------------
 
 *******************************************************************************/
import $ from 'jquery';
import { sgiLogger } from './sgiLogger';
/**
 * @namespace 客户端通用服务调用方法集
 * @alias commonClient
 */
const commonClient = {

	/**
	 * 缺省描述（请作者补充一下）
	 * @param {*} serviceId 
	 * @param {*} refreshDBKey 
	 * @param {*} params 
	 * @param {*} refreshTableCallBack 
	 * @param {*} objFct 
	 */
	callBatch: function (serviceId, refreshDBKey, params, refreshTableCallBack, objFct) {
		if (!params || !refreshTableCallBack || !refreshDBKey) {
			return;
		}

		//设置前处理,讲分批信息放入到request中
		var beforefunc = function (request) {
			if (!request.head) request.head = {};

			if (params.pageSize) {
				request.head.pageSize = parseInt(params.pageSize);
			} else {
				request.head.pageSize = 10;
			}
			if (params.current) {
				request.head.offset = params.current;
			} else {
				request.head.offset = 1;
			}
		};
		//设置后处理，负责取值刷新
		let recordCount;
		var afterfunc = function (response) {
			if (!response.head) response.head = {};
			const pageCount = response.head.pageCount;
			recordCount = response.head.recordCount;
		};
		var res = commonClient.call(serviceId, objFct, afterfunc, beforefunc);

		const rtList = objFct.get(refreshDBKey);
		refreshTableCallBack(recordCount, rtList);

		return res;
	},

	/**
	 * 缺省描述（请作者补充一下）
	 * @param {*} serviceId 
	 * @param {*} objFct 
	 * @param {*} aftercall 
	 * @param {*} beforecall 
	 * @param {*} callback 
	 * @param {*} flag 
	 */
	call: function (serviceId, objFct, aftercall, beforecall, callback, flag) {
		if (!serviceId || !objFct) {
			return;
		}
		beforecall = beforecall || function () { };
		aftercall = aftercall || function () { };

		let guid = serviceId.replace("_SI_", "_SV_");

		let prm = PrmFactory.getPrm(guid);
		if (!prm) {
			return;
		}
		let path = prm.subSVID;
		let type = prm.svType;
		let app = prm.belong;

		let request = {};
		let header = {
			'Content-Type': "application/json; charset=utf-8"
			//'Content-Type': "application/x-www-form-urlencoded; charset=utf-8"
		};

		let head = {};
		head.serviceId = serviceId;
		head.cvt = "vi";
		request.head = head;

		let data = {};
		let cfgs = prm.cldSet || [];
		cfgs.forEach(cfg => {
			let io = cfg.iobType;
			let mult = cfg.isMult;

			let instance = cfg.oKey;

			if (!(io == 'I' || io == 'B')) return;
			var value = objFct.get(instance);
			if (!value) { return; }
			if (mult) {
				let cvtList = [];
				value.forEach(obj => {
					let cvtObj = {};
					let bks = cfg.cfgs || [];
					bks.forEach(cbk => {
						let buskey = cbk.busCode || cbk.fieldCode;
						if (!buskey || !obj[buskey]) return;
						cvtObj[buskey] = obj[buskey];
					});
					cvtList.push(cvtObj);
				});
				let dKey = cfg.dKey || cfg.eoName;
				data[dKey] = cvtList;
			} else {
				// for (var f in value) {
				// 	data[f] = value[f];
				// }
				var bks = cfg.cfgs || [];
				bks.forEach(cbk => {
					let buskey = cbk.busCode || cbk.fieldCode;
					if (!buskey || value[buskey] == null) return;//空字符串允许通过
					data[buskey] = value[buskey];
				});
			}
		});
		request.body = data;

		beforecall(request);

		let response = {};
		let sucfunc = function (res) {
			response = res || {};
		};
		let failfunc = function (xhr, textStatus, errorThrown) {
			sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
			if (!response.head) {
				response.head = {};
			}
			response.head.code = xhr.status;
			response.head.msg = textStatus
		}
		let url = sgiConfig.service + "/" + app + path;
		request = tool.jsonToStr(request);
		sgiLogger.log("request:", request);

		sgiClient.restcall(url, type, request, header, false, sucfunc, failfunc);

		sgiLogger.log("response:", response);
		aftercall(response);

		let code = response.head.code;
		let msg = response.head.msg;
		let result = response.body;
		if (code === "00000000") {
			cfgs.forEach(cfg => {
				let io = cfg.iobType;
				let mult = cfg.isMult;

				let instance = cfg.oKey;

				if (!(io == 'O' || io == 'B')) return;

				if (mult) {
					let dKey = cfg.dKey;
					let eoKey = cfg.eoName;
					if (!dKey) {
						dKey = eoKey;
					}
					objFct.set(instance, result[dKey]);
				} else {
					var vo = {};
					var bks = cfg.cfgs || [];
					bks.forEach(cbk => {
						let buskey = cbk.busCode || cbk.fieldCode;
						if (!buskey || !result[buskey]) return;
						vo[buskey] = result[buskey]
					});
					objFct.set(instance, vo);
				}
			});
		}
		return { code: code, msg: msg };
	},

	/**
	 * 服务接口调用
	 * @param {string} SIID 服务接口guid
	 * @param {ObjFactory} objFct 对象工厂实例
	 * @param {boolean} flag 异步标识
	 * @param {function} callback 回调函数，(res)=>{}
	 * @param {string} reqType 服务调用类型，默认POST
	 */
	callSIOld: function (SIID, objFct, flag, callback, reqType = "POST") {
		if (!SIID || !objFct) return;

		let prm = PrmFactory.getPrm(SIID);
		if (!prm || !prm.guid) return;

		// let path = prm.subSVID;//服务描述guid
		let path = prm.url;//服务地址
		// let type = prm.svType;
		// let app = prm.belong;

		let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
		request.head.serviceId = SIID;
		request.head.cvt = "vi";

		let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
		if (!header['Content-Type']) header['Content-Type'] = "application/json; charset=utf-8";

		let data, inInst, outInst;
		let cfgs = prm.cldSet || [];
		cfgs.some(cfg => {
			let io = cfg.iobType;//输入输出类型
			// let mult = cfg.isMult;//是否多条
			let instance = cfg.oKey;//实例名
			if (!inInst && io == "I") {
				inInst = instance;
				data = objFct.get(instance);
			}
			if (!outInst && io == "O") {
				outInst = instance;
			}
			return inInst && outInst;
		});
		request.body = data;

		let response = { head: {}, body: {} };
		let sucfunc = function (res) {
			// 赋值
			response = res || {};
			// session超时校验
			if (res && res.head && (res.head.code == '0405' || res.head.code == '0401')) {
				// 失效 重新登录
				if (tool && tool.logout) {
					// message.warning('登录超时，请重新登录');
					tool.popMessage("登录超时，请重新登录", "warning");
					tool.logout();
				}
				return;
			} else {
				// 成功，对象工厂赋值
				objFct.set(outInst, res.body);
			}
			// 回调
			if (callback && typeof callback == "function") callback(res);
		};
		let failfunc = function (xhr, textStatus, errorThrown) {
			sgiLogger.error("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
			response.head.code = xhr.status;
			response.head.msg = textStatus
			// 回调
			if (callback && typeof callback == "function") callback(response);
		}

		let url = sgiConfig.service + "/" + path;
		request = tool.jsonToStr(request);
		sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);

		return response;
	},
	/**
	   * 服务接口调用
	   * @param {string} SIID 服务接口guid
	   * @param {ObjFactory} objFct 对象工厂实例
	   * @param {boolean} flag 异步标识
	   * @param {function} callback 回调函数，(res)=>{}
	   * @param {string} reqType 服务调用类型，默认POST
	   */
	callSI: function (SIID, objFct, req, flag, callback, reqType = "POST", assistBody) {
		if (!SIID || !objFct) return;

		//let path = prm.url; //服务地址
		// let type = prm.svType;
		// let app = prm.belong;

		let request = {
			head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {},
		};
		request.head.serviceId = SIID;
		request.head.cvt = "vi";
		// 增加辅助信息
		request.assistBody = assistBody

		let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
		if (!header["Content-Type"])
			header["Content-Type"] = "application/json; charset=utf-8";

		request.body = req;

		let response = { head: {}, body: {} };
		let sucfunc = function (res) {
			// 赋值
			response = res || {};
			// session超时校验
			if (
				res &&
				res.head &&
				(res.head.code == "0405" || res.head.code == "0401")
			) {
				// 失效 重新登录
				if (tool && tool.logout) {
					// message.warning('登录超时，请重新登录');
					tool.popMessage("登录超时，请重新登录", "warning");
					tool.logout();
				}
				return;
			} else {
				// 成功，对象工厂赋值
				//objFct.set(outInst, res.body);
			}
			// 回调
			if (callback && typeof callback == "function") callback(res);
		};
		let failfunc = function (xhr, textStatus, errorThrown) {
			console.error(
				"状态码" +
				xhr.status +
				" - " +
				xhr.readyState +
				",错误信息" +
				textStatus
			);
			response.head.code = xhr.status;
			response.head.msg = textStatus;
			// 回调
			if (callback && typeof callback == "function") callback(response);
		};

		//let url = sgiConfig.service + "/" + path;

		let url = sgiSrvUrl.service + "/bdl/invoke/" + SIID;
		request = tool.jsonToStr(request);
		sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);

		return response;
	},
	/**
	 * 发送服务请求
	 * @param {string} path 服务地址
	 * @param {any} data 请求数据
	 * @param {function} callback 服务返回后回调
	 * @param {boolean} flag 异步标识，默认false
	 * @param {string} reqType 请求类型 POST|GET|···
	 * @param {function} aftercall 请求后处理 (res)=>void
	 * @param {function} beforecall 请求前处理 (request)=>void
	 */
	simplecall: function (path, data, callback, flag, reqType, aftercall, beforecall) {
		if (!path) {
			return;
		}

		//wzhe 2020-3-10
		//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
		let url;
		let siGuid;
		if (path.constructor === Object) {
			url = path.siUrl;
			siGuid = path.rlsGuid;
		} else {
			url = path;
		}

		let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
		//wzhe 2020-3-10
		//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
		request.head.serviceId = siGuid;

		if (data) {
			request.body = data;
		}

		if (beforecall) {
			beforecall(request);
		}

		request = tool.jsonToStr(request);

		let response = { head: {}, body: {} };
		let sucfunc = function (res) {
			response = res;

			//session超时校验
			if (response && response.head && (response.head.code == '0405' || response.head.code == '0401')) {
				//失效 重新登录
				if (tool && tool.logout) {
					// message.warning('登录超时，请重新登录');
					tool.popMessage("登录超时，请重新登录", "warning");
					tool.logout();
				}
				return;
			}

			if (callback) {
				callback(res);
			}
			if (aftercall) {
				aftercall(res);
			}
		};
		let failfunc = function (xhr, textStatus, errorThrown) {
			sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
			response.head.code = xhr.status;
			response.head.msg = textStatus
			if (callback) {
				callback(response);
			}
			if (aftercall) {
				aftercall(response);
			}
		}
		// let url = path;

		let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
		if (!reqType) {
			reqType = 'post';
			header['Content-Type'] = "application/json; charset=utf-8";
		}
		//wzhe 2020-3-10
		//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
		header.serviceId = siGuid;

		sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);

		return response;
	},

	/**
	 * 缺省描述（请作者补充一下）
	 * @param {*} path 
	 * @param {*} request 
	 * @param {*} callback 
	 * @param {*} flag 
	 * @param {*} reqType 
	 * @param {*} aftercall 
	 * @param {*} beforecall 
	 */
	requestCall: function (path, request, callback, flag, reqType, aftercall, beforecall) {
		if (!path) {
			return;
		}

		if (request) {
			let head = request.head;
			if (!head) head = request.head = {};
			if (tool && tool.getLoginInfo) {
				Object.assign(head, tool.getLoginInfo());
			}
		} else {
			request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
		}


		if (beforecall) {
			beforecall(request);
		}

		request = tool.jsonToStr(request);

		let response = { head: {}, body: {} };
		let sucfunc = function (res) {
			response = res;

			//session超时校验
			if (response && response.head && (response.head.code == '0405' || response.head.code == '0401')) {
				//失效 重新登录
				if (tool && tool.logout) {
					// message.warning('登录超时，请重新登录');
					tool.popMessage("登录超时，请重新登录", "warning");
					tool.logout();
				}
				return;
			}

			if (callback) {
				callback(res);
			}
			if (aftercall) {
				aftercall(res);
			}
		};
		let failfunc = function (xhr, textStatus, errorThrown) {
			sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
			response.head.code = xhr.status;
			response.head.msg = textStatus
			if (callback) {
				callback(response);
			}
			if (aftercall) {
				aftercall(response);
			}
		}
		let url = path;

		let header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
		if (!reqType) {
			reqType = 'post';
			header['Content-Type'] = "application/json; charset=utf-8";
		}

		sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);

		return response;
	}

}
window.commonClient = commonClient;

/**
 * @namespace 参数服务请求方法集
 * @alias sgiPfClient
 */
const sgiPfClient = {
	/**
	 * 缺省描述（请作者补充一下）
	 * @param {*} url 
	 * @param {*} method 
	 * @param {*} datas 
	 * @param {*} header 
	 * @param {*} async 
	 * @param {*} success 
	 * @param {*} failure 
	 * @param {*} callback 
	 */
	restcall: function (url, method, datas, header, async, success, failure, callback) {
		url = url || 'http://pf.server.com/pf';
		datas = datas || {};
		datas.head = { ...datas.head, ...(tool && tool.getLoginInfo ? tool.getLoginInfo() : {}) }
		header = { ...header, ...(tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {}) }
		var head = header || {};

		async = async || false;

		var result = undefined;
		var successfunc = function (datas, textStatus, xhr) {
			result = datas;
			if (result && result.head && (result.head.code == '0405' || result.head.code == '0401')) {
				//失效 重新登录
				if (tool && tool.logout) {
					// message.warning('登录超时，请重新登录');
					tool.popMessage("登录超时，请重新登录", "warning");
					tool.logout();
				}
				return;
			}
			if (success) {
				success(datas, textStatus, xhr);
			}
		}
		let failfunc = function (xhr, textStatus, errorThrown) {
			sgiLogger.log("pfclient:状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
			if (failure) {
				failure(xhr, textStatus, errorThrown);
			}
		}
		sgiLogger.time("pfclient");//计时器jqueryAjax开始
		sgiClient.jqueryAjax(url, method, datas, head, async, successfunc, failfunc, callback);
		sgiLogger.timeEnd("pfclient");//计时器jqueryAjax结束
		return result;
	}

}
window.sgiPfClient = sgiPfClient;

/**
 * @namespace 服务调用方法集
 * @alias sgiClient
 */
const sgiClient = {

	/**
	 * 缺省描述（请作者补充一下）
	 * @param {*} url 
	 * @param {*} method 
	 * @param {*} datas 
	 * @param {*} head 
	 * @param {*} async 
	 * @param {*} success 
	 * @param {*} failure 
	 * @param {*} callback 
	 * @param {*} callbefore 
	 */
	restcall: function (url, method, datas, head, async, success, failure, callback, callbefore) {
		url = url || '';
		async = async || false;
		datas = datas || {};
		head = head || { 'Content-Type': "application/json; charset=utf-8" };

		this.jqueryAjax(url, method, datas, head, async, success, failure, callback, callbefore);
	},
	/**
	 * 缺省描述（请作者补充一下）
	 * @param {*} url 
	 * @param {*} method 
	 * @param {*} datas 
	 * @param {*} head 
	 * @param {*} async 
	 * @param {*} success 
	 * @param {*} failure 
	 * @param {*} callback 
	 * @param {*} callbefore 
	 */
	jqueryAjax: function (url, method, datas, head, async, success, failure, callback, callbefore) {
		method = method.toUpperCase() || 'POST';
		if (method == "GET") {
			datas = undefined;
		}
		$.ajax({
			type: method,
			async: async,
			url: url,
			headers: head,
			data: datas,
			beforeSend: callbefore,
			success: success,
			error: failure,
			complete: callback,
			// dataType: 'json'
		});
	},

	// ajax: function (url, method, datas, async, success, failure, callback) {
	// 	try {
	// 		method = method.toUpperCase() || 'POST';
	// 		url = url || '';
	// 		async = async || false;
	// 		datas = datas || {};
	// 		success = success || function () { };
	// 		failure = failure || function () { };
	// 		callback = callback || function () { };

	// 		var xmlHttp = null;
	// 		if (XMLHttpRequest) {
	// 			xmlHttp = new XMLHttpRequest();
	// 		} else {
	// 			xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
	// 		}
	// 		xmlHttp.withCredentials = true;
	// 		xmlHttp.onreadystatechange = function () {
	// 			if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
	// 				success(xmlHttp.responseText);
	// 			} else {
	// 				failure(xmlHttp.responseText);
	// 			}
	// 			callback(xmlHttp.responseText);
	// 		};

	// 		var params = [];
	// 		params.push("_method=" + method);
	// 		for (var key in datas) {
	// 			params.push(key + '=' + datas[key]);
	// 		}
	// 		var req = params.join('&');
	// 		if (method.toUpperCase() === 'GET') {
	// 			//xmlHttp.open('GET', url + '?' + req, async);
	// 			//xmlHttp.send(null);
	// 			xmlHttp.open('GET', url, async);
	// 			xmlHttp.send(req);
	// 		} else {
	// 			xmlHttp.open('POST', url, async);
	// 			xmlHttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8');
	// 			xmlHttp.send(req);
	// 		}
	// 	} catch (e) {

	// 	}
	// }
}
window.sgiClient = sgiClient;

export { sgiClient, sgiPfClient, commonClient }


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCommon/sgiClient.js